import { REHYDRATE } from 'redux-persist';

const persist = (state, action) => {
    switch (action.type) {
        case REHYDRATE:
            return Object.assign({}, state.rehydrated,
                { rehydrated: true });
        default:
            return state;
    }
};

export default persist;



// WEBPACK FOOTER //
// ./src/reducers/persist.js